import React, { useEffect } from 'react';
import Icon from '../Icon/Icon';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import styles from './PhotoFullscreenModal.module.css';

interface PhotoFullscreenModalProps {
  open: boolean;
  src: string;
  alt?: string;
  onClose: () => void;
}

const PhotoFullscreenModal: React.FC<PhotoFullscreenModalProps> = ({
  open,
  src,
  alt = 'Foto',
  onClose,
}) => {
  useEscapeToClose(onClose, open);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={alt}
    >
      <button
        type="button"
        className={styles.closeBtn}
        onClick={onClose}
        aria-label="Fechar visualização"
      >
        <Icon name="close" size={24} />
      </button>
      <img
        src={src}
        alt={alt}
        className={styles.image}
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};

export default PhotoFullscreenModal;
